module.exports = "/wp-content/themes/aly-2-markkinointisaitti/static/images/arrow-white.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/icons/arrow-white.svg
// module id = 22
// module chunks = 2